module.exports = __webpack_public_path__ + "img/dashboard.0fd4b7d6.webp";